import {Directive} from '@angular/core';

@Directive({
    selector: '[ngxAurTableSubFooterRow]',
    standalone: false
})
export class NgxTableSubFooterRowDirective {
  constructor() {}
}
